import React from 'react';
import Metrics from '@spotahome/soyuz-tracking';

import { Button } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import './EmptyFavorites.scss';

const handleGoBackToSearch = () => {
  Metrics.ga.sendEvent(
    'My favorites',
    'go to home page button',
    'click button'
  );
};

const EMPTY_FAVORITES_IMAGE =
  'https://df4usm6ck0nqa.cloudfront.net/images/logged_favorites.svg';

const EmptyFavoritesNotLogged = () => (
  <div className="empty-favorites" id="no-results">
    <img
      className="empty-favorites__image"
      src={EMPTY_FAVORITES_IMAGE}
      alt={trans('favorites.message.continue_searching')}
    />

    <p className="empty-favorites__text">
      {trans('favorites.message.will_appear')}
    </p>
    <div className="empty-favorites__button-container">
      <Button
        className="ga-favorites-page-account-link"
        href="/"
        onClick={() => handleGoBackToSearch}
      >
        {trans('favorites.message.continue_searching')}
      </Button>
    </div>
  </div>
);

export default EmptyFavoritesNotLogged;
